
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBChip, MDBAlert, MDBIcon } from "mdb-react-ui-kit";
import { getLocalizedText } from '../../utils/localizedText';

export default function SelectTopics({ isActive, setSelectedTopics, selectedTopics, parentTopicGroups = [], maxSelect }) {
  const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const maxReached = selectedTopics.length >= maxSelect;

  const handleChipClick = (topic) => {
    if (selectedTopics.includes(topic.id)) {
      setSelectedTopics(selectedTopics.filter(id => id !== topic.id));
    } else if (maxSelect === 1) {
      setSelectedTopics([topic.id]);
    } else if (!maxReached) {
      setSelectedTopics([...selectedTopics, topic.id]);
    } else {
      setShowAlert(true);
    }
  };

  if (!isActive) return null;

  return (
    <>
      {maxReached && (
        <div className="bg-info bg-opacity-10 text-info mb-3 p-3 rounded-pill d-flex align-items-center">
          <MDBIcon fas icon="info-circle" className="me-2" />
          {t("You can select a maximum of {{count}} topics", { count: maxSelect })}
        </div>
      )}
      <div className="row">
        {parentTopicGroups.map((topicGroup) => (
          <div key={topicGroup.id} className="mb-4 col-12 col-lg-6">
            <h6 className="fw-bold mb-2">
              {getLocalizedText(topicGroup.name)}
            </h6>
            <hr className="mt-0 mb-2" />
            <div className="d-flex flex-wrap gap-2">
              {topicGroup.topics.items.map((topic) => {
                const isSelected = selectedTopics.includes(topic.id);
                return (
                  <MDBChip
                    key={topic.id}
                    className={`cursor-pointer m-0 ${isSelected ? "bg-success text-white" : ""} ${maxReached && !isSelected ? "opacity-50" : ""}`}
                    onClick={() => handleChipClick(topic)}
                  >
                    {getLocalizedText(topic.name)}
                  </MDBChip>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <MDBAlert
        color='danger'
        autohide
        position='bottom-right'
        delay={2000}
        appendToBody
        open={showAlert}
        onClose={() => setShowAlert(false)}
      >
        {t("You can only select up to") + " " + maxSelect + " " + t("topics")}
      </MDBAlert>
    </>
  );
}
